import { useMutation, useQueryClient } from "@tanstack/react-query";
import giftCategoriesClient, {
  PendulumLogo,
} from "../../../../api/giftCategories";

const useCreateLogoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (logo: Partial<PendulumLogo>) =>
      giftCategoriesClient.createLogo(logo),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["logos"] });
    },
  });
};

export default useCreateLogoMutation;
